// extracted by mini-css-extract-plugin
export default {"melodyVideo":"lK-z","isFullWidth":"mK-z","landingPageVideo":"nK-z","play":"oK-z","iframeVideo":"pK-z","playHidden":"qK-z","fullwidth":"rK-z"};